module.exports = __webpack_public_path__ + "assets/img/coupon.5127d159.png";